import jaLocale from 'element-ui/lib/locale/lang/ja'//element言語パックの導入
const ja = {
    posterPage: {
        title1: 'サブスクリプション機能がオンラインになります！',
        title2: '購読継続料、特権アップグレード！',
        title3: '専属割引、継続料金がお得',
        title4: '両替コードを取得すると、デバイスを購入した販売業者に問い合わせることができます',
        title5: '優先的な体験機能',
        function1: '機能の詳細：',
        function2: 'ベーシックサービスの継続料金（同時通訳、会議アシスタント、インテリジェントアシスタント）...',
        function3: '付加価値サービス購読（オフライン翻訳、音声ビデオ通話翻訳）..',
    },
    RedemptionCodePage: {
        RedemptionCode: '兌換コード',
        ValueAddedServices: '付加価値サービス',
        UpgradedExperience: '専属付加価値権益、体験アップグレード',
        OfflineTranslation: 'オフライン翻訳',
        NoInternet: 'ネットワーク接続不要・インスタント翻訳不要・安全で信頼性の高い',
        GoToSubscribe: '購読に行く',
        AudioAndVideoCall: '音声/ビデオ通話',
        RealTimeCall: 'リアルタイム音声翻訳・コミュニケーションに支障がない',
        BaseService: 'ベーシックサービス',
        AIAssistant: '機能：同時通訳・会議アシスタント・AIアシスタント',
        LanguagesSetting: '言語設定',
        languages1: '簡体字中国語',
        languages2: '繁体字中国語',
        languages3: '英語',
        languages4: '日本語',
        languages5: '韓国語',
        languages6: 'ロシア語',
        languages7: 'スペイン語',
        languages8: 'フランス語',
        languages9: 'ドイツ語',
        languages10: 'ポルトガル語',
        languages11: 'イタリア語',
        languages12: 'トルコ語',
        languages13: 'ベトナム語',
        languages14: 'インドネシア語',
        languages15: 'ヒンディー語',
        languages16: 'アラビア語',
        languages17: 'タイ語',
        languages18: 'ペルシア語',
    },
    Login: {
        ToLogin: 'ログイン',
        PhoneLogin: '携帯番号登録',
        EmailLogin: 'メールボックスログイン',
        PhonePlaceholder: '携帯番号を入力してください',
        EmailPlaceholder: 'Enter email',
        Code: '認証コード',
        and: 'と',
        BeforeText: 'アカウントを作成することで、同意して遵守することができます。',
        UserAgreement: 'ユーザプロトコル',
        privacy: 'プライバシーポリシー',
        errorMessage: '認証コードエラー',
        readTitle: '次のプロトコルを読んで同意する',
        readBefore: '個人情報の安全を保証するために、まず読んで同意してください',
        cancel: 'キャンセル',
        agree: '同意して続行する',
        error1: '有効なメールアドレスを入力してください',
        error2: '正しい携帯番号を入力してください',
        error3: '認証コードを入力してください',
        success: 'ログイン成功'
    },
    OffLinePage: {
        title: 'オフライン翻訳',
        NoInternet: 'ネットワーク接続不要・インスタント翻訳不要・安全で信頼性の高い',
        ServiceLife: '使用期間',
        forever: '永続的な使用',
        describe: 'サブスクリプションの説明',
        describeItem1: '1.オフライン翻訳機能は一括払い、永続的に使用され、使用権限はBluetoothデバイスに従い、デバイスを交換する場合は、オフライン翻訳変換コードを再購読する必要があります。',
        describeItem2: '2.ライセンスコードを購読した後は返金できません。',
        describeItem3: '3.10言語対応：中国語、英語、ドイツ語、日本語、韓国語、ヒンディー語、タイ語、スペイン語、フランス語、ロシア語。',
        quantity: '数量',
        payType: '支払い方法',
        card: '銀行カード',
        wx: 'ウィーチャット',
        GooglePay: 'Google Pay',
        subscribe: '購読',
        RMB: '¥',
        confirm: '確認',
        cardNumber: 'カード番号',
        periodOfValidity: '有効期間',
        safetyCode: 'セキュリティコード',
        name: '名前',
        yearAndMonth: '年/月',
        message1: '数量は0にできません',
        popTip:'暖かいヒント',
        popText1:'よく読んで理解してください',
        popText2:'オフライン翻訳有料プロトコル',
        popText3:'読んで同意しました',
        popText4:'読んで同意しました',
    },
    AudioVideoPage: {
        title: '音声/ビデオ通話',
        RealTime: 'リアルタイム音声翻訳・コミュニケーションに支障がない',
        describe: 'サブスクリプションの説明',
        describeItem1: '1.音声ビデオ通話翻訳機能はチャージ購入分数、分数は通話開始から時間を計算し、権限はアカウントに従い、他のアカウントにログインする場合は再チャージする必要がある。',
        describeItem2: '2.アカウントがチャージされた後、異なるデバイスを接続してバインドすることができます。',
        describeItem3: '3.音声ビデオ通話翻訳機能はチャージ後は返金できない。',
        payType: '支払い方法',
        card: '銀行カード',
        wx: 'ウィーチャット',
        GooglePay: 'Google Pay',
        subscribe: '購読',
        RMB: '¥',
        sale: '割引',
        confirm: '確認',
        time1: '秒',
        time2: '分',
        time3: '時間',
        time4: '日',
        time5: '月',
        time6: '年',
    },
    OffLineResult: {
        title1: 'オフライン翻訳',
        title2: '音声/ビデオ通話',
        title3: 'ベーシックサービス',
        success: '購読に成功しました',
        fail: '購読に失敗しました',
        stock: '両替コード準備中',
        saveTitle: '両替コードを保存して、APPへ両替に行きます',
        code: '兌換コード',
        tip1: 'このコードはオフライン翻訳機能',
        tip2: 'このコードは音声/ビデオ通話翻訳機能',
        tip3: 'このコードは、基本サービスのチャージバック機能を交換するためだけに使用されます',
        save: '保存',
        time: '購読時間：',
        copy: 'コピー',
        copySuccess: 'コピー成功',
        loading: 'ロード中',
        paySuccess:'支払いに成功しました'
    },
    RedemptionList: {
        title: '私の両替コード',
        view: '表示',
        time: '購読時間：',
    },
    MyRedemption: {
        title: '私の両替コード',
        code: '兌換コード',
        time: '購読時間：',
        copy: 'コピー',
        tip1: 'このコードはオフライン翻訳機能',
        tip2: 'このコードは音声/ビデオ通話翻訳機能',
        tip3: 'このコードは、基本サービスのチャージバック機能を交換するためだけに使用されます',
        save: '保存',
        success: '操作が成功しました',
    },
    basePage: {
        error1: '商品情報が取得されていません',
        message1: '商品をお選びください',
        title: 'ベーシックサービス',
        function: '機能：同時通訳・会議アシスタント・AIアシスタント',
        describe: 'サブスクリプションの説明',
        describe1: '1.同時通訳、会議アシスタントなどの基礎サービスを継続した後、有効期間は設備に従い、設備を交換する場合、再継続費が必要である。',
        describe2: '2.基礎サービスを継続した後は返金できません。',
        payType: '支払い方法',
        card: '銀行カード',
        wx: 'ウィーチャット',
        GooglePay: 'Google Pay',
        subscribe: '購読',
        RMB: '¥',
        sale: '割引',
        month: '月',
        confirm: '確認',
        month1: '1ヶ月',
        month2: '半年',
        month3: '1年間'
    },
    ...jaLocale//ここでelement言語パックを導入する目的は、言語を切り替える際に、elementのコンポーネント内の文字が切り替えに従うことができるようにすることです
}
//エクスポート
export default ja;
